import { v2ApiClient } from './apiClient';

export const dashboardService = {
  async getStudentDashboard() {
    const response = await v2ApiClient.get('/lms/class/student/dashboard');
    if (response && response.isSuccessful) {
      return response;
    }
    throw new Error(response?.message || 'Failed to retrieve dashboard data');
  }
};

export default dashboardService;
